<div class="flex">
  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <ng-container *ngIf="business$ | async as business">
      <div class="w-full relative mb-4">
        <app-feature-flag-tabs>
          <sbnb-page-header navTabs>
            <div class="flex gap-2 items-center">
              <sbnb-back-button class="!hidden md:block" label=" "></sbnb-back-button>
              <h2 class="flex-1 text-center sbnbDesktop:text-left nomargin">
                {{ business.name }}
              </h2>
              <sbnb-badge context="neutral">{{ business.type | humanize }}</sbnb-badge>
            </div>
          </sbnb-page-header>
        </app-feature-flag-tabs>
      </div>
      <!-- <mat-tab-group [selectedIndex]="2">
        <mat-tab label="General & Properties"> -->
      <div class="mt-4">
        <sbnb-business-form
          *ngIf="business"
          [business]="business"
          [editing]="true"
          (saveSuccess)="onSave()"></sbnb-business-form>
      </div>
      <!-- </mat-tab>
        <mat-tab label="Accounting">
          <div class="mt-4"><sbnb-business-accounting [business]="business"></sbnb-business-accounting></div>
        </mat-tab>
      </mat-tab-group> -->
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
